import React from 'react';

import { Flex, ScrollArea, Title, useMantineTheme } from '@mantine/core';
import { HEADER_HEIGHT } from 'shared/constants/theme';

interface DashboardPageWrapperProps {
  title: string | React.ReactNode;
  icon?: React.ReactNode;
  rightComponent?: React.ReactNode;
  offsetScrollbars?: boolean;
  scrollAreaRef?: React.RefObject<HTMLDivElement>;
  children: React.ReactNode;
}

export function DashboardPageWrapper({
  title,
  icon,
  rightComponent,
  offsetScrollbars,
  scrollAreaRef,
  children
}: DashboardPageWrapperProps) {
  const theme = useMantineTheme();

  return (
    <Flex w="100%" h="100%" mah="100svh" direction="column">
      <Flex
        px={24}
        h={HEADER_HEIGHT}
        py={0}
        direction="row"
        align="center"
        justify="space-between"
        style={{ borderBottom: `1px solid ${theme.other.gray.border}`, flexShrink: 0 }}>
        <Flex direction="row" align="center" gap={10}>
          {icon}
          {typeof title === 'string' ? <Title variant="h1">{title}</Title> : title}
        </Flex>
        {rightComponent}
      </Flex>
      <ScrollArea
        px={24}
        mb={theme.other.shellPadding}
        viewportRef={scrollAreaRef}
        h="100%"
        w="100%"
        style={{ flexGrow: 1 }}
        offsetScrollbars={offsetScrollbars}>
        {children}
      </ScrollArea>
    </Flex>
  );
}
